'use client'

import LayoutModal, { LayoutModalProps } from '@components/popup/layout-modal'
import useI18n from '@hooks/client/useI18n'
import useLocale from '@hooks/client/useLocale'

import Form from './form'

import styles from './search.module.scss'

import PopularSearches from './popular-searches'

export default function Search({ isOpen, close }: Omit<LayoutModalProps, 'children' | 'title'>): JSX.Element {
  const i18n = useI18n()
  const locale = useLocale()
  return (
    <LayoutModal
      isOpen={isOpen}
      close={close}
      title={
        <h2
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: `Search over <span>${i18n.jobs} jobs</span>` }}
        />
      }
    >
      <h3 className={styles.subtitle}>The {locale.toUpperCase()}’s top jobs. All in one place.</h3>
      <Form close={close} />
      <PopularSearches close={close} locale={locale} />
    </LayoutModal>
  )
}
